import React from "react";
import {BrowserRouter as Router, Routes, Route,} from 'react-router-dom';
import { Helmet } from "react-helmet";
// Screens
import Landing from "./screens/Landing.jsx";
import 'bootstrap/dist/css/bootstrap.css';
import Posts from "./screens/Posts.jsx";
import Post from "./screens/Post.jsx";
import FAQs from "./components/Sections/FAQs.jsx";
import NoInternet from "./services/NoInternet.js";
import DataDeletionInfo from "./components/Sections/DataDeletionInfo";
import HowItWorks from "./components/Sections/HowItWorks.jsx";
import FinancialInclusionSection from "./components/Sections/FinancialInclusion.jsx";
import FeaturesSection from "./components/Sections/Features.jsx";
import ExpressInteresPage from "./screens/EoiPage.jsx";
import InvestorPitchPage from "./screens/pitch.jsx";
import ReviseEoiPage from "./screens/RevisedEoiPage.jsx";
import ExpressOfInterestLandingPage from "./screens/RevisedEoiPage.jsx";
import MastaKashSaccoLanding from "./screens/MastakashSaccoLandingPage.jsx";
import MastaKashFundraising from "./screens/FundraisingLandingPage.jsx";
import MastaKashPilotLandingPage from "./screens/PilotLandingPage.jsx";
//import EOIDashboard from "./screens/EoiDashboard.jsx";




function App() {

  return(

    <NoInternet>
      <>
      <Helmet>
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />
        <link href="https://fonts.googleapis.com/css2?family=Khula:wght@400;600;800&display=swap" rel="stylesheet" />
      </Helmet>
     
 
       
      <Routes>
      <Route exact path="/" element={<Landing/>}/>
     <Route exact path="/blog" element={<Posts/>}/>
     <Route exact path="/blog/:slug/:id" element={<Post/>}/>
     <Route exact path="/faqs" element={<FAQs/>}/>
     <Route exact path="/how-it-works" element={<HowItWorks/>}/>
      <Route exact path="/financial-inclusion" element={<FinancialInclusionSection/>}/>
      <Route exact path="/features" element={<FeaturesSection/>}/>
      <Route exact path="/invest" element={<InvestorPitchPage/>}/>
      <Route exact path="/mastakash-fund" element={<MastaKashFundraising/>}/>
            <Route exact path="/mastakash-pilot" element={<MastaKashPilotLandingPage/>}/>
     <Route exact path="/delete-personal-data" element={<DataDeletionInfo/>}/>
      <Route exact path="/no-internet-connection" element={<NoInternet/>}/>
      <Route exact path="/mastakash-eoi" element={<ExpressOfInterestLandingPage/>}/>
        <Route exact path="/saccos" element={<MastaKashSaccoLanding/>}/>

      {/*<Route exact path="/eoi-dashboard" element={<EOIDashboard/>}/>*/}



       

      
      </Routes>
  

      
      
      </>


    </NoInternet>

  );

  
 
}

export default App;

